// Pronoun options

export const pronouns = [
    {
        title: "She/Hers",
        subject: "she",
        subjectCaps: "She",
        object: "her",
        objectCaps: "Her",
        possesive: "her",
        possesiveCaps: "Her",
        subjectIs: "she is",
        subjectIsCaps: "She is",
        possesiveHas: "she has",
        possesiveHasCaps: "She has",
        self: "herself",
        selfCaps: "Herself",
    },
    {
        title: "He/His",
        subject: "he",
        subjectCaps: "He",
        object: "his",
        objectCaps: "His",
        possesive: "him",
        possesiveCaps: "Him",
        subjectIs: "he is",
        subjectIsCaps: "He is",
        possesiveHas: "he has",
        possesiveHasCaps: "He has",
        self: "himself",
        selfCaps: "Himself",
    },
    {
        title: "They/Theirs",
        subject: "they",
        subjectCaps: "They",
        object: "their",
        objectCaps: "Theirs",
        possesive: "them",
        possesiveCaps: "Them",
        subjectIs: "they are",
        subjectIsCaps: "They are",
        possesiveHas: "they have",
        possesiveHasCaps: "They have",
        self: "themselves",
        selfCaps: "Themselves",
    },
    {
        title: "Ze/Hir",
        subject: "ze",
        subjectCaps: "Ze",
        object: "hir",
        objectCaps: "Hir",
        possesive: "hir",
        possesiveCaps: "Hir",
        subjectIs: "ze is",
        subjectIsCaps: "Ze is",
        possesiveHas: "Ze has",
        possesiveHasCaps: "Ze has",
        self: "hirself",
        selfCaps: "Hirself",
    },
    {
        title: "Xe/Xyr",
        subject: "xe",
        subjectCaps: "Xe",
        object: "xyr",
        objectCaps: "Xyr",
        possesive: "xyr",
        possesiveCaps: "Xyr",
        subjectIs: "xe is",
        subjectIsCaps: "Xe is",
        possesiveHas: "xe has",
        possesiveHasCaps: "Xe has",
        self: "xemself",
        selfCaps: "Xemself",
    },
];